import { useEffect, useState } from "react";

import { PersonalisationHeading } from "./PersonalisationHeading";
import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

interface PreparingScreenProps {
  durationMs: number;
  userFirstName?: string | null;
}

export const PreparingScreen = ({
  durationMs,
  userFirstName,
}: PreparingScreenProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    "Analyzing your goals",
    "Filtering out treatments that don't match",
    "Comparing to over 2 million real patients",
    "Personalizing your experience",
    `Your experience has now been fully customized to you, ${userFirstName}.`,
  ];

  useEffect(() => {
    const timeouts: NodeJS.Timeout[] = [];

    timeouts.push(setTimeout(() => setCurrentStep(1), durationMs));
    timeouts.push(setTimeout(() => setCurrentStep(2), durationMs * 2));
    timeouts.push(setTimeout(() => setCurrentStep(3), durationMs * 3));
    timeouts.push(setTimeout(() => setCurrentStep(4), durationMs * 4));

    return () => {
      timeouts.forEach((timeout) => clearTimeout(timeout));
    };
  }, [durationMs]);

  return (
    <PersonalisationScreenLayout contentClassName="flex h-full items-center justify-center p-8">
      <div
        key={currentStep}
        className="duration-500 ease-out animate-in fade-in slide-in-from-bottom-2"
      >
        <PersonalisationHeading size="sm" className="text-center">
          {steps[currentStep]}
        </PersonalisationHeading>
      </div>
    </PersonalisationScreenLayout>
  );
};
